export const logger = {
  error: console.error,
  warn: console.warn,
  info: console.info,
  debug: console.log, //console.debug to hide
  log: console.log,
};
